import { API } from "./axios";

export const getClientMatters = async () => {
  return API.get("/clientportal/matters");
};

export const getClientMatterInfo = async (matterId) => {
  return API.get(`/clientportal/matters/${matterId}`);
};

export const getMessages = async (matterId) => {
  return API.get(`/clientportal/${matterId}/messages`);
};

export const addMessage = async (matterId, data) => {
  return await API.post(
    `/clientportal/${matterId}/messages`,
    JSON.stringify({ data })
  );
};

export const getTasks = async (matterId) => {
  return API.get(`/clientportal/${matterId}/tasks`);
};

export const getUserScreen = async (screenId) => {
  return API.get(`/clientportal/userscreen/${screenId}`);
};

export const getMatterVariables = async (matterId) => {
  return API.get(`/clientportal/${matterId}/variables`);
};

export const updateMatterVariables = async (matterId, data) => {
  return API.put(
    `/clientportal/${matterId}/variables`,
    JSON.stringify({ data })
  );
};
